import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _QualityErrorTypes, _QualityMeasurementInspections } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    idGarment?: number;
}

export const SelectQualityMeasurementInspections = ({ idSelector, onChange, label, returnType = "ID", idGarment }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityMeasurementInspections);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, [idGarment]);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDQualityMeasurementInspections === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDQualityMeasurementInspections,
                    label: `${found.DataBeanProperties.CodeMeasurement ? `${found.DataBeanProperties.CodeMeasurement} -` : ""} ${found.DataBeanProperties.Name} `,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        const props: any = {
            State: 1,
        }
        if (idGarment) props.IDQualityGarment = idGarment;
        instance.getQualityMeasurementInspectionsCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                if (resp) setLista(resp);
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDQualityMeasurementInspections,
        label: `${item.DataBeanProperties.CodeMeasurement ? `${item.DataBeanProperties.CodeMeasurement} -` : ""} ${item.DataBeanProperties.Name} `,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Cota"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona una cota..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
